/**
 * Converts a JavaScript value to a JavaScript Object Notation (JSON) string.
 * @param value A JavaScript value, usually an object or array, to be converted.
 * @returns value as JSON string
 */
export function hbsHelperJson(value: string): string {
  return JSON.stringify(value);
}